import React, { useState } from 'react'
import PropTypes from 'prop-types'

import PrimaryButton from '@components/inputs/button/primaryButton'
import Loading from '../../loading'

import {
  CloseIcon,
  Container,
  ButtonArea,
  Title,
  Subtitle,
  ErrorContainer,
  DetailsButton,
  Error,
} from './styles'

import 'material-icons/iconfont/outlined.css'
import Modal from '..'

const NotificationModal = ({
  title,
  subtitle,
  primaryButtonLabel,
  onClickPrimary,
  loading,
  isOpen,
  setClose,
  style,
  titleStyle,
  error,
}) => {
  const [showDetails, setShowDetails] = useState(false)

  const toggleDetails = () => {
    setShowDetails(!showDetails)
  }
  return (
    <Modal
      isOpen={isOpen}
      style={{
        width: '350px',
        height: '220px'
      }}
    >
      <Container style={style}>
        <CloseIcon
          className="material-icons-outlined"
          onClick={setClose}
        >
          close
        </CloseIcon>
        <Title style={titleStyle}>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        {error && (
          <ErrorContainer>
            <DetailsButton onClick={toggleDetails}>
              <span className="material-symbols-outlined">
                {showDetails ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
              </span>
              {showDetails ? 'Ocultar detalhes' : 'Ver detalhes'}
            </DetailsButton>
            {showDetails && (
              <Error style={{ display: showDetails ? 'block' : 'hidden' }}>
                <span style={{ fontWeight: 'bold' }}>Detalhes: </span>
                {error}
              </Error>
            )}
          </ErrorContainer>
        )}
        <ButtonArea>
          <PrimaryButton onClick={onClickPrimary}>
            {loading ? <Loading /> : primaryButtonLabel}
          </PrimaryButton>
        </ButtonArea>
      </Container>
    </Modal>
  )
}

NotificationModal.propTypes = {
  isOpen: PropTypes.bool,
  setClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  primaryButtonLabel: PropTypes.string,
  onClickPrimary: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  style: PropTypes.object,
  titleStyle: PropTypes.object,
  error: PropTypes.string,
}

NotificationModal.defaultProps = {
  isOpen: false,
  title: 'Continuar ?',
  subtitle: null,
  primaryButtonLabel: 'Sim',
  loading: false,
  style: null,
  titleStyle: null,
  error: null,
}

export default NotificationModal
